import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createCallCenterInsightsApi } from './';
import { createFakePostResponder } from '../../test-utils';
export var createCallCenterInsightsApiTestkit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createCallCenterInsightsApi(parent, fakeHttp);
    var base = parent + "/analytics/callCenter";
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, base + "/overview"),
        whenGetCallQueueTransfersData: createFakePostResponder(fakeHttp, base + "/transfers"),
        whenGetCallVolumeCounts: createFakePostResponder(fakeHttp, base + "/callVolume/counts"),
        whenGetCallVolumeHistogram: createFakePostResponder(fakeHttp, base + "/callVolume/histogram"),
        whenGetAbandonRateCounts: createFakePostResponder(fakeHttp, base + "/abandonRate/counts"),
        whenGetAbandonRateHistogram: createFakePostResponder(fakeHttp, base + "/abandonRate/histogram"),
        whenGetHandleTimeCounts: createFakePostResponder(fakeHttp, base + "/handleTime/counts"),
        whenGetHandleTimeHistogram: createFakePostResponder(fakeHttp, base + "/handleTime/histogram"),
        whenGetSatisfactionScoreCumulative: createFakePostResponder(fakeHttp, base + "/satisfactionScore/cumulative"),
        whenGetSatisfactionScoreHistogram: createFakePostResponder(fakeHttp, base + "/satisfactionScore/histogram"),
        whenGetWaitTimeCounts: createFakePostResponder(fakeHttp, base + "/waitTime/counts"),
        whenGetWaitTimeHistogram: createFakePostResponder(fakeHttp, base + "/waitTime/counts"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map